<template>
	<div>
		<div class="container px-4">
			<div class="md:flex">
				<div class="w-full md:w-1/3 lg:w-1/4 mb-8 md:mb-0">
					<img class="w-3/4 md:w-full mx-auto" src="/img/benchmark/speed-test.svg" />
				</div>
				<div class="flex flex-col w-full md:w-2/3 lg:w-3/4 px-8">
					<h4 class="text-2xl lg:text-4xl font-serif mb-8 text-center">
						Take The Cloud Sites Challenge
					</h4>

					<p class="text-center w-full lg:w-3/4 mx-auto leading-loose">
						We have carefully crafted this benchmark to accurately compare our
						speeds to the top competitors. We have installed and optimized an
						identical WordPress site on each provider's hosting plan, utilizing
						each provider's features and resources to their fullest. There's no
						tricks involved, what you’re about to see is an actual page load for
						each site. We'll let you decide which service is the winner.
					</p>

					<button v-on:click="start" :disabled="running" :class="
					  !running
					    ? 'no-underline rounded block text-center bg-red-600 text-white hover:shadow-lg hover:bg-red-500 p-4 lg:py-3 lg:px-8 font-medium text-lg lg:text-base font-serif lg:font-sans ease-in-out duration-500 mx-auto mt-8'
					    : 'no-underline rounded block text-center bg-red-200 text-white hover:bg-red-100 p-4 lg:py-3 lg:px-8 font-medium text-lg lg:text-base font-serif lg:font-sans ease-in-out duration-500 mx-auto mt-8'
					">
						Start Your Engines <zap-icon></zap-icon>
					</button>
				</div>
			</div>

			<div class="flex flex-wrap lg:flex-no-wrap lg:space-x-8" v-if="running || done">
				<frame v-for="site in sites" :key="site.id" :ref="site.id" v-bind="site" @finished="trackFinished"></frame>
			</div>

			<div v-if="done" class="flex flex-col mt-8 p-8 bg-white mx-auto rounded-md shadow-lg border border-gray-100" ref="completedDiv">
				<h4 class="text-3xl font-serif mb-8 text-center">
					The Choice Is Clear!
				</h4>

				<bar-chart :chartoptions="chartoptions" @rendered="scrollView" class="m-4 max-h-lg" />

				<p class="text-center text-sm tracking-wide leading-loose md:max-w-3/4 mx-auto">
					It's clear that Izoox Cloud Sites platform not only stands up to the
					rest, but beats most by more than a margin in performance and price.
					When you back that combination with a support team that was hand
					picked to make your website fly, you cannot beat that value.
				</p>

				<a href="/getting-started" class="block no-underline rounded text-center bg-red-600 text-white hover:shadow-lg hover:bg-red-500 p-4 lg:py-3 lg:px-8 font-medium text-lg lg:text-base font-serif lg:font-sans ease-in-out duration-500 mx-auto mt-8">
					Take The Leap Today!
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import BarChart from "./Chart.vue"
import { ZapIcon } from "vue-feather-icons"
import Frame from "./Frame"

export default {
	name: "SpeedBenchmark",
	components: { ZapIcon, Frame, BarChart },
	data() {
		return {
			sites: [
				{
					id: "izoox",
					url: "https://izooxbenchmark.com",
					logo: "/img/logo/gray.svg"
				},
				{
					id: "siteground",
					url: "https://sitegroundbenchmark.com",
					logo: "/img/competitors/siteground.svg"
				},
				{
					id: "wpengine",
					url: "https://wpenginebenchmark.com",
					logo: "/img/competitors/wpengine.svg"
				},
				{
					id: "bluehost",
					url: "https://bluehostbenchmark.com",
					logo: "/img/competitors/bluehost.svg"
				}
			],
			queue: null,
			loaded: null,
			chartoptions: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							scaleLabel: {
								display: true,
								labelString: "Load Time in milliseconds"
							},
							ticks: {
								beginAtZero: true
							}
						}
					]
				}
			}
		}
	},
	computed: {
		running: function () {
			return this.loaded !== null && this.loaded <= this.sites.length
		},
		done: function () {
			return this.loaded !== null && this.loaded > this.sites.length
		}
	},
	methods: {
		start() {
			this.queue = this.loaded = null
			if (!this.running) {
				this.$nextTick(() => {
					this.loaded = 0
					this.initialize()
				})
			}
		},
		initialize() {
			this.queue = this.sites.map(function (site) {
				return site.id
			})

			this.$nextTick(() => {
				this.trackFinished()
			})
		},
		trackFinished() {
			this.sites.forEach(site => {
				let component = this.$refs[site.id][0]

				$("iframe", component.$el)
					.removeClass("border-blue-500")
					.addClass("border-gray-600")
			})

			if (this.queue.length > 0) {
				let key = this.queue.shift()
				let component = this.$refs[key][0]

				$("iframe", component.$el)
					.addClass("border-blue-500")
					.removeClass("border-gray-600")

				component.go()
			}

			this.loaded++
		},
		scrollView() {
			$("html, body").velocity("scroll", {
				offset: $(this.$refs.completedDiv).offset().top - 125,
				duration: 1000
			})
		}
	}
}
</script>
